module.exports = __webpack_public_path__ + "img/赛诺龙.5c3a761.png";